import React, { useEffect, useRef, useState } from 'react';
import Subtitle from './Subtitle'
import Fields from './Fields'
import Timeline from './Timeline';
import config from '../config.js';

const FieldsGroup = ({fields_groups, data, timeline = false}) => {
    // console.log(fields_groups)
    // console.log(data)

    const containerRef = useRef(null);

    const getData = (key, data) => {
        console.log(key);
        switch (key) {
            case "leaser":
            case "start":
            case "steps":
            case "infos":
            case "impayes":
            case "suiviclient":
                return data[key]
                break;
                    
            default:
                return data;
                break;
        }
    }

    return (
        <>
            {fields_groups && (
                <div className={`grid grid-cols-1 relative`} ref={containerRef}>
                    
                    {timeline && (
                        <div className="timeline absolute left-3 top-0 h-full w-10">
                            <Timeline containerRef={containerRef} use_middle_placement={false} use_gradient={true} current_step={data.current_step}/>
                        </div>
                    )}

                    {fields_groups.map((fg, index) => {
                        // Check if the field group should be hidden if empty
                        const shouldHide = fg.hide_if_empty === true;
                        // console.log(fg);
                        // console.log(getData(fg.key, data))
                        // Only render if the group should not be hidden when empty
                        if (!shouldHide) {
                            return (
                                <div key={fg.key} id={fg.key} className={timeline ? 'pl-14' : ''}>
                                    <div className="px-4 timeline-big-item">
                                        <Subtitle icon={fg.icon}>{fg.name}</Subtitle>
                                        <div className="px-2">
                                            <Fields 
                                                fields={fg.fields} 
                                                data={getData(fg.key, data)} 
                                                wrapper_class="py-2" 
                                            />
                                        </div>
                                        <hr className="border-mgray mt-2 mb-8" />
                                    </div>
                                </div>
                            );
                        }
                        
                    })}
                </div>
            )}
        </>
    )
}

export default FieldsGroup;